import { Box, Tab, Tabs } from "@mui/material";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  ROUTE_CERTIFICATION_NEW,
  ROUTE_CRAFTING_VIDEO,
  ROUTE_EDUCATION_NEW,
  ROUTE_PROFILER,
  ROUTE_PROMPT,
  ROUTE_RECORDING_TIPS,
  ROUTE_SKILLSET_NEW,
  ROUTE_UPLOAD_FINAL_VIDEO,
} from "../../constants/routes";

const tabs = [
  {
    label: "EDUCATION & WORK EX.",
    route: ROUTE_EDUCATION_NEW,
  },
  {
    label: "SPECIALIZATIONS",
    route: ROUTE_SKILLSET_NEW,
    route2: ROUTE_CERTIFICATION_NEW,
  },
  {
    label: "VIDEO",
    route: ROUTE_CRAFTING_VIDEO,
    route2: ROUTE_PROMPT,
    route3: ROUTE_RECORDING_TIPS,
    route4: ROUTE_UPLOAD_FINAL_VIDEO,
  },
  {
    label: "PERSONALITY",
    route: ROUTE_PROFILER,
  },
];

const ProfileTabs = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);

  // Set the initial tab based on the current route
  useEffect(() => {
    const currentTab = tabs.findIndex(
      (tab) =>
        tab.route === location.pathname ||
        tab?.route2 === location.pathname ||
        tab?.route3 === location.pathname ||
        tab?.route4 === location.pathname
    );
    setSelectedTab(currentTab === -1 ? 0 : currentTab);
  }, [location.pathname]);

  // const handleTabChange = (event: any, newValue: any) => {
  //   setSelectedTab(newValue);
  //   navigate(tabs[newValue].route);
  // };

  return (
    <Box sx={{ overflowX: "auto" }}>
      <Tabs
        variant="scrollable"
        // textColor="#181818"
        indicatorColor="primary"
        value={selectedTab}
        // onChange={handleTabChange}
        sx={{
          "& .MuiTabs-indicator": {
            height: "6px",
            backgroundColor: "#52C6AE !important",
            borderRadius: "5px 5px 5px 5px",
            top: 6,
            bottom: "auto",
            transform: "translateY(-100%)",
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={index} label={tab.label} />
        ))}
      </Tabs>
    </Box>
  );
};

export default ProfileTabs;
